/**
 * Mingle Mage factory catalog administration client (MM-727 slice 4). A subclass in its own module so
 * the Mingle Mage app, whose entry chunk has no headroom, never bundles the admin methods.
 */
import { MingleMageClient, NO_AUTOMATIC_RETRY } from './mingle-mage-client.js';
export class MingleMageFactoryAdminClient extends MingleMageClient {
    // MM-727 slice 4 — factory catalog administration (`mingle-mage:factory:admin`). Mutations are
    // not auto-retried: a replayed put would turn a lost response into a spurious 409.
    async getAdminFactoryCatalog() {
        return this.get('/api/v1/admin/factory-catalog');
    }
    async createFactorySet(request) {
        return this.post('/api/v1/admin/factory-catalog/sets', request, undefined, NO_AUTOMATIC_RETRY);
    }
    async updateFactorySet(setId, request) {
        return this.patch(`/api/v1/admin/factory-catalog/sets/${encodeURIComponent(setId)}`, request, undefined, NO_AUTOMATIC_RETRY);
    }
    async reorderFactorySets(request) {
        return this.put('/api/v1/admin/factory-catalog/sets-order', request, undefined, NO_AUTOMATIC_RETRY);
    }
    async putFactorySequence(sequenceId, request) {
        return this.put(`/api/v1/admin/factory-catalog/sequences/${encodeURIComponent(sequenceId)}`, request, undefined, NO_AUTOMATIC_RETRY);
    }
    /** `setId: null` demotes (kept as unassigned). */
    async assignFactorySequence(sequenceId, request) {
        return this.put(`/api/v1/admin/factory-catalog/sequences/${encodeURIComponent(sequenceId)}/assignment`, request, undefined, NO_AUTOMATIC_RETRY);
    }
}
